import { Color } from "@repo/app-types/constants/colors";
import type { Size } from "@repo/ui/helpers/helpers";
import { Pill } from "@repo/ui/Pills/pill";
import { PillSkeleton } from "@repo/ui/Pills/pillSkeleton";
import type { FC, ReactNode } from "react";

export interface AverageCountPillProps {
  size: Size;
  value: number | undefined;
  isLoading?: boolean;
  renderCount: (value: number) => ReactNode;
}

export const AverageCountPill: FC<AverageCountPillProps> = (props) => {
  if (props.value === undefined && props.isLoading) {
    return <PillSkeleton size={props.size} />;
  }

  if (props.value === undefined) {
    return <Pill color={Color.Gray} size={props.size} label="N/A" />;
  }

  return (
    <Pill
      color={Color.Gray}
      size={props.size}
      label={props.renderCount(props.value)}
    />
  );
};
